module.exports = __webpack_public_path__ + "img/convertBlock.f6e1d390.svg";